import Axios from "axios";
import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";

import { getAlert, formatCurrency } from "../../utils/SamuiUtils";
import Navbar from "../components/Modal/Navbar";

function Home() {
  const [countPurchase, setCountPurchase] = useState(0);
  const [countWarehouse, setCountWarehouse] = useState(0);
  const [countSellproducts, setCountSellproducts] = useState(0);
  const [list, setlist] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      // นับจำนวนธุรกรรมของ Purchase ทั้งหมด
      const countPurchase = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/count-purchase`,
        {
          comp_id: window.localStorage.getItem("company"),
        },
        {
          headers: {
            key: process.env.REACT_APP_ANALYTICS_KEY,
          },
        }
      );
      setCountPurchase(countPurchase.data[0].Count);

      // นับจำนวนธุรกรรมของ Warehouse ทั้งหมด
      const countWarehouse = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/count-warehouse`,
        {
          comp_id: window.localStorage.getItem("company"),
        },
        {
          headers: {
            key: process.env.REACT_APP_ANALYTICS_KEY,
          },
        }
      );
      setCountWarehouse(countWarehouse.data[0].Count);

      // นับจำนวนธุรกรรมของ SellProducts ทั้งหมด
      const countSellproducts = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/count-sellproducts`,
        {
          comp_id: window.localStorage.getItem("company"),
        },
        {
          headers: {
            key: process.env.REACT_APP_ANALYTICS_KEY,
          },
        }
      );
      setCountSellproducts(countSellproducts.data[0].Count);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };
  const company = localStorage.getItem("company");

  return (
    <div className="Home">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container-fluid">
            <div className="page-inner py-4">
              {/* Page Header */}
              <div className="d-flex align-items-center justify-content-between mb-4">
                <Breadcrumbs page="Dashboard" items={[]} />
              </div>
              <div style={{ height: "90vh", overflowY: "auto" }}>
                {/* Cards Section */}
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 g-4">
                  {/* Card Template */}
                  {[
                    {
                      title: "จัดซื้อสินค้า",
                      icon: "fas fa-shopping-cart",
                      bgColor: "bg-warning",
                      count: formatCurrency(countPurchase).split(".")[0],
                      link: "/purchase",
                    },
                    {
                      title: "คลังสินค้า",
                      icon: "fas fa-building",
                      bgColor: "bg-warning",
                      count: formatCurrency(countWarehouse).split(".")[0],
                      link: "/warehouse",
                    },
                    {
                      title: "ใบเบิก-ใบยืม",
                      icon: "fas fa-retweet",
                      bgColor: "bg-warning",
                      count: "0",
                      link: "/borrow-withdrawal",
                    },
                    {
                      title: "ขายสินค้า",
                      icon: "fas fa-tags",
                      bgColor: "bg-warning",
                      count: "0",
                      link: "/sellproducts",
                    },
                    {
                      title: "งานบัญชี",
                      icon: "fas fa-credit-card",
                      bgColor: "bg-warning",
                      count: "0",
                      link: "/account",
                    },
                    {
                      title: "ข้อมูลตั้งต้น",
                      icon: "fas fa-folder",
                      bgColor: "bg-warning",
                      count: "0",
                      link: "/initialdata",
                    },
                  ].map((card, index) => (
                    <div className="col" key={index}>
                      <div
                        className="card h-100 border-primary shadow-sm"
                        style={{
                          cursor: "pointer",
                          transition: "transform 0.2s",
                        }}
                        onClick={() => window.location.replace(card.link)}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.transform = "scale(1.05)")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.transform = "scale(1)")
                        }
                      >
                        <div className="card-body d-flex align-items-center">
                          <div
                            className={`me-3 text-center text-white ${card.bgColor} rounded-circle p-4`}
                          >
                            <i className={`${card.icon} fa-2x`}></i>
                          </div>
                          <div>
                            <p className="card-category text-muted mb-1">
                              {card.title}
                            </p>
                            <h4 className="card-title mb-0">
                              {card.count} รายการ
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {company === "2" ? (
                  <div
                    className="card  border-primary shadow-sm mt-4 p-4"
                    style={{ width: "50%", height: "30vh", marginBottom: 10 }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: 10,
                      }}
                    >
                      <p style={{ fontWeight: "bold", fontSize: "20px" }}>
                        ประวัติลูกค้าไม่ได้สั่งเกิน 7 วัน
                      </p>
                      <div className="navbar-form nav-search">
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="ค้นหาชื่อลูกค้า..."
                            className="form-control"
                            // value={searchTerm}
                            // onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <span className="input-group-text">
                            <i className="fas fa-search"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="row">
                        <div
                          className=" mb-1"
                          style={{ borderRight: "2px solid #c7c8c9" }}
                        >
                          <div
                            className="table-responsive"
                            style={{ maxHeight: "650px", overflowY: "auto" }}
                          >
                            <table
                              id="basic-datatables"
                              className="table table-striped table-hover"
                            >
                              <thead className="thead-dark">
                                <tr>
                                  <th
                                    className="text-center"
                                    style={{ width: "5%" }}
                                  >
                                    No.
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    รหัสลูกค้า
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ width: "45%" }}
                                  >
                                    ชื่อลูกค้า
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    วันที่ซื้อล่าสุด
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ width: "20%" }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "baseline",
                                        justifyContent: "center",
                                        textAlign: "center",
                                        height: "30px",
                                      }}
                                    >
                                      <p>ระยะเวลา</p>
                                      <button
                                        style={{
                                          background: "transparent",
                                          border: "none",
                                        }}
                                        onClick={() => setlist(!list)}
                                      >
                                        <i
                                          className="fas fa-arrow-up fw-bold"
                                          style={
                                            list === false
                                              ? { color: "black" }
                                              : { color: "white" }
                                          }
                                        ></i>

                                        <i
                                          className="fas fa-arrow-down fw-bold"
                                          style={
                                            list === true
                                              ? { color: "black" }
                                              : {
                                                  color: "white",
                                                  marginLeft: 4,
                                                }
                                          }
                                        ></i>
                                      </button>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <div>
                                <tbody></tbody>
                              </div>
                              {/* <tbody>
                {filteredItemData.length > 0 ? (
                  filteredItemData.map((data, index) => (
                    <tr
                      key={data.Doc_Id || index + 1}
                      onClick={() => onRowSelected(data)}
                      style={{ cursor: 'pointer' }}>
                      <td className="text-center">{formatThaiDateUi(data.Doc_Date)}</td>
                      <td className="text-center">
                        {data.Doc_Status !== 13 ? (
                          <button
                            className="btn"
                            style={{
                              backgroundColor: data.DocBLStatusPaid_Colour,
                              color: 'white',
                              width: '100%'
                            }}
                          >
                            {data.DocBLStatusPaid_Name}
                          </button>
                        ) : (
                          <button
                            className="btn"
                            style={{
                              backgroundColor: 'black',
                              color: 'white',
                              width: '100%'
                            }}
                          >
                            ยกเลิก
                          </button>
                        )}
                      </td>
                      <td className="text-center">{data.Doc_No}</td>
                      <td className="text-center">
                        {data.Doc_INV_No || '-'}
                        {data.Doc_INV_No && (
                          <>
                            <button
                              className="btn btn-link btn-sm px-3"
                              onClick={() => { setSelectInvNo(data.Doc_INV_No); setShowOptionInvModal(true) }}
                            >
                              <i
                                className="fa fa-print"
                                style={{ fontSize: "16px" }}
                              ></i>
                            </button>
                            {showOptionInvModal && (
                              <PrintInvoiceModal
                                showOptionInvModal={showOptionInvModal}
                                setShowOptionInvModal={setShowOptionInvModal}
                                onHandleInvoice1={() => getReport('inv1', selectInvNo)}
                                onHandleInvoice2={() => getReport('inv2', selectInvNo)}
                              />
                            )}
                          </>
                        )}
                      </td>
                      <td className="text-left">{data.AR_Name}</td>
                      <td className="text-end">{formatCurrency(data.BL_Total)}</td>
                      <td className="text-center">
                        <button className="btn btn-sm" onClick={() => onPageUpdate(data.Doc_No)}>
                          <i className="fa fa-edit" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">
                      <center>
                        <h5>ไม่พบข้อมูล</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody> */}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          {/* <Footer /> */}
        </div>
      </div>
    </div>
  );
}

export default Home;
